import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';

initMain([], {
    PqrQuery: () => import('./vue/components/pqr-query/PqrQuery.vue')
}, []);
header();